import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "./api";
import { AppThunk } from "./app";
import API_URL from "../config/ApiUrl";

interface ProviderState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as ProviderState;

const ProviderSlice = createSlice({
  name: "Provider",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = ProviderSlice.actions;

export const fetchAddProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PROVIDER.ADD, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PROVIDER.LIST, payload);
      return Promise.resolve(response.data.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchActiveProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PROVIDER.ACTIVE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchDeleteProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PROVIDER.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateEmailInProvider =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PROVIDER.UPDATE_EMAIL, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getProviderListByCodes = (): AppThunk<any> => async () => {
  try {
    const response = await api.get(API_URL.PROVIDER.LIST_BY_CODES);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export default ProviderSlice.reducer;
